import type { RuleSet } from '../types';

export const cssTagged = new WeakSet<RuleSet<any>>();
